/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/coldefs/metadata/molecule
 * @desc Column Definition for metadata molecule
 */

import {
  fieldCAS,
  fieldMolecularFormula,
  fieldMolecularWeight,
  fieldName,
} from 'labstep-web/components/PubChemMetadata/Form/fields';
import { getMetadataMoleculePubchemColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/metadata/molecule/pubchem';
import { getMetadataMoleculeSafetyColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/metadata/molecule/safety';
import { getMetadataMoleculeStructureColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/metadata/molecule/structure';
import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/types';
import type { Experiment } from 'labstep-web/models/experiment.model';
import type { MetadataType } from 'labstep-web/models/metadata/types';
import type { Protocol } from 'labstep-web/models/protocol.model';

export const getMetadataMoleculeColDef = (
  experimentOrProtocol: Experiment | Protocol,
  parentEntityClass: string,
  metadataType: MetadataType,
  metadataLabel: string,
  field: string,
  protocolValueName?: string,
): SmartTableColDef | null => {
  switch (field) {
    case 'structure':
      return getMetadataMoleculeStructureColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    case fieldName.name:
      return getMetadataMoleculePubchemColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        'Name',
        fieldName,
        protocolValueName,
      );
    case fieldCAS.name:
      return getMetadataMoleculePubchemColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        'CAS Number',
        fieldCAS,
        protocolValueName,
      );
    case fieldMolecularFormula.name:
      return getMetadataMoleculePubchemColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        'Molecular Formula',
        fieldMolecularFormula,
        protocolValueName,
      );
    case fieldMolecularWeight.name:
      return getMetadataMoleculePubchemColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        'Molecular Weight',
        fieldMolecularWeight,
        protocolValueName,
      );
    case 'safety':
      return getMetadataMoleculeSafetyColDef(
        experimentOrProtocol,
        parentEntityClass,
        metadataType,
        metadataLabel,
        protocolValueName,
      );
    default:
      return null;
  }
};
